import { StateProvince } from "../lookup/state-province";
import { PersonEmail } from "./person-email";
import { PersonPhone } from "./person-phone";

export enum GenderType {
    Unspecified = 1,
    Male = 2,
    Female = 3
}


export interface Person {
    id?: number;
    firstName?: string;
    lastName?: string;
    primaryEmail?: PersonEmail;
    primaryPhone?: PersonPhone;
    isClient?: boolean;
    gender?: GenderType;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    state?: StateProvince;
    postalCode?: string;
    firstLastName?: string;
}